module.exports = __webpack_public_path__ + "media/images/icon-tel-6f1ec70197282598dcc1bdfbef574e07.svg";